export enum TrialState {
	ActiveWithDownloads = 'ActiveWithDownloads',
	ActiveNoDownloads = 'ActiveNoDownloads',
	NotInTrial = 'NotInTrial',
}
